var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.mobile
    ? _c(
        "header",
        { class: ["page-header", { "page-header--is-fixed": _vm.isFixed }] },
        [
          _c(
            "div",
            { staticClass: "page-header__row" },
            [
              _c(
                "nuxt-link",
                { staticClass: "header-logo", attrs: { to: _vm.homePath } },
                [
                  _c("img", {
                    staticClass: "header-logo__image",
                    attrs: {
                      width: "144",
                      height: "64",
                      src: require("static/images/header-logo.svg"),
                      alt: ""
                    }
                  })
                ]
              ),
              _c("div", { staticClass: "header-menu" }, [
                _vm.nav && _vm.nav.length
                  ? _c(
                      "nav",
                      {
                        class: [
                          "header-navbar",
                          { "header-navbar--open": _vm.isOpenNav }
                        ]
                      },
                      [
                        _c(
                          "ul",
                          {
                            class: [
                              "header-nav",
                              {
                                "header-nav--has-active-sub":
                                  _vm.isActiveSub !== null
                              }
                            ]
                          },
                          _vm._l(_vm.nav, function(item, index) {
                            return _c(
                              "li",
                              { staticClass: "header-nav__item" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "header-nav__box-title" },
                                  [
                                    _c(
                                      "nuxt-link",
                                      {
                                        class: [
                                          "header-nav__title",
                                          {
                                            "header-nav__title--active":
                                              item.isActive
                                          }
                                        ],
                                        attrs: { to: "/" + item.route },
                                        nativeOn: {
                                          click: function($event) {
                                            return _vm.closeNav($event)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(item.title) +
                                            "\n\t\t\t\t\t\t\t"
                                        )
                                      ]
                                    ),
                                    item.sub
                                      ? _c("div", {
                                          staticClass: "header-nav__btn-sub",
                                          on: {
                                            click: function($event) {
                                              return _vm.openSub(index)
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                item.sub
                                  ? _c(
                                      "div",
                                      {
                                        class: [
                                          "header-nav__sub",
                                          {
                                            "header-nav__sub--active":
                                              _vm.isActiveSub === index
                                          }
                                        ]
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "header-nav__sub-body"
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "header-nav__sub-name"
                                              },
                                              [_vm._v(_vm._s(item.title))]
                                            ),
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "header-nav__sub-list"
                                              },
                                              _vm._l(item.sub, function(
                                                subItem
                                              ) {
                                                return _c(
                                                  "li",
                                                  {
                                                    staticClass:
                                                      "header-nav__sub-item"
                                                  },
                                                  [
                                                    _c(
                                                      "nuxt-link",
                                                      {
                                                        class: [
                                                          "header-nav__sub-title",
                                                          {
                                                            "header-nav__sub-title--active":
                                                              subItem.isActive
                                                          }
                                                        ],
                                                        attrs: {
                                                          to:
                                                            "/" +
                                                            subItem.route +
                                                            (subItem.type
                                                              ? "?type=" +
                                                                subItem.type
                                                              : subItem.brand
                                                              ? "?brand=" +
                                                                subItem.brand
                                                              : "")
                                                        },
                                                        nativeOn: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.toggleNav(
                                                              $event
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                            _vm._s(
                                                              subItem.title
                                                            ) +
                                                            "\n\t\t\t\t\t\t\t\t\t\t"
                                                        )
                                                      ]
                                                    )
                                                  ],
                                                  1
                                                )
                                              }),
                                              0
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "header-tools" },
                  [
                    _c(
                      "btn",
                      {
                        class: [
                          "header-tools__back",
                          {
                            "header-tools__back--active":
                              _vm.isActiveSub !== null
                          }
                        ],
                        attrs: { tag: "control" },
                        nativeOn: {
                          click: function($event) {
                            return _vm.closeSub($event)
                          }
                        }
                      },
                      [_c("icon-arrow", { attrs: { mod: "left" } })],
                      1
                    ),
                    _c(
                      "btn",
                      {
                        class: ["header-tools__localization", _vm.langTitle],
                        attrs: { tag: "control" },
                        nativeOn: {
                          click: function($event) {
                            return _vm.toggleLang($event)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t" + _vm._s(_vm.langTitle) + "\n\t\t\t\t"
                        )
                      ]
                    ),
                    _c(
                      "btn",
                      {
                        class: [
                          "header-tools__search",
                          {
                            "header-tools__search--active": _vm.isOpenSearch,
                            "header-tools__search--hidden":
                              _vm.isActiveSub !== null
                          }
                        ],
                        attrs: { tag: "control" },
                        nativeOn: {
                          click: function($event) {
                            return _vm.toggleSearch($event)
                          }
                        }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "header-tools__search-icon",
                            attrs: {
                              width: "12",
                              height: "12",
                              viewBox: "0 0 12 12"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M7.3 0C4.7 0 2.6 2.1 2.6 4.7c0 .9.3 1.8.8 2.5L0 10.6 1.4 12l3.4-3.4c.7.5 1.6.8 2.5.8 2.6 0 4.7-2.1 4.7-4.7S9.9 0 7.3 0zm0 7.4c-1.5 0-2.7-1.2-2.7-2.7C4.6 3.2 5.8 2 7.3 2 8.8 2 10 3.2 10 4.7c0 1.5-1.2 2.7-2.7 2.7z"
                              }
                            })
                          ]
                        ),
                        _c("div", {
                          staticClass: "header-tools__search-close-icon"
                        })
                      ]
                    ),
                    _c("btn", {
                      class: [
                        "header-tools__nav",
                        { "header-tools__nav--active": _vm.isOpenNav }
                      ],
                      attrs: { tag: "control" },
                      nativeOn: {
                        click: function($event) {
                          return _vm.toggleNav($event)
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "form",
                  {
                    class: [
                      "header-search",
                      { "header-search--open": _vm.isOpenSearch }
                    ],
                    attrs: { action: _vm.searchAction },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.$router.push(
                          _vm.searchAction +
                            "?req=" +
                            _vm.$refs.searchField.value
                        )
                      }
                    }
                  },
                  [
                    _c(
                      "btn",
                      {
                        staticClass: "header-search__submit",
                        attrs: { tag: "control" }
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "header-search__submit-icon",
                            attrs: {
                              width: "12",
                              height: "12",
                              viewBox: "0 0 12 12"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M7.3 0C4.7 0 2.6 2.1 2.6 4.7c0 .9.3 1.8.8 2.5L0 10.6 1.4 12l3.4-3.4c.7.5 1.6.8 2.5.8 2.6 0 4.7-2.1 4.7-4.7S9.9 0 7.3 0zm0 7.4c-1.5 0-2.7-1.2-2.7-2.7C4.6 3.2 5.8 2 7.3 2 8.8 2 10 3.2 10 4.7c0 1.5-1.2 2.7-2.7 2.7z"
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _c("input", {
                      ref: "searchField",
                      staticClass: "header-search__field",
                      attrs: { type: "text", required: "" }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e3f60d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e3f60d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PageHeader.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4e3f60d2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/PageHeader.vue
// module chunks = 5